"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachPastChatsSheet = AttachPastChatsSheet;
exports.attachPastChatsButtonLabel = attachPastChatsButtonLabel;
var _react = require("react");
var _checkbox = require("@design/ui/checkbox");
var _label = require("@design/ui/label");
var _searchInput = require("@design/ui/search-input");
var _truncatedTextWithCursorTooltip = require("../../truncated-text-with-cursor-tooltip");
var _chatComposerPastChatsList = require("../chat-composer-past-chats-list");
var _useAttachableConversations = require("../../../hooks/use-attachable-conversations");
var _useDebouncedValue = require("../../../hooks/use-debounced-value");
var _useInfiniteScrollSentinel = require("../../../hooks/use-infinite-scroll-sentinel");
var _importedBottomSheet = require("./imported-bottom-sheet");
var _jsxRuntime = require("react/jsx-runtime");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function attachPastChatsButtonLabel(selectedPastChatCount) {
  return selectedPastChatCount > 1 ? "Attach ".concat(selectedPastChatCount, " Past Chats") : "Attach Past Chat";
}
function AttachPastChatsSheet(_ref) {
  var onClose = _ref.onClose,
    excludeConversationId = _ref.excludeConversationId,
    attachedConversationIds = _ref.attachedConversationIds,
    onAttachConversation = _ref.onAttachConversation;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedPastChats = _useState4[0],
    setSelectedPastChats = _useState4[1];
  var debouncedQuery = (0, _useDebouncedValue.useDebouncedValue)(query, _useDebouncedValue.SEARCH_DEBOUNCE_MS);
  var _useAttachableConvers = (0, _useAttachableConversations.useAttachableConversations)(debouncedQuery),
    items = _useAttachableConvers.items,
    isLoadingInitial = _useAttachableConvers.isLoadingInitial,
    isLoadingMore = _useAttachableConvers.isLoadingMore,
    hasMore = _useAttachableConvers.hasMore,
    hasError = _useAttachableConvers.hasError,
    loadMore = _useAttachableConvers.loadMore;
  var sentinelRef = (0, _useInfiniteScrollSentinel.useInfiniteScrollSentinel)({
    hasMore: hasMore,
    isLoadingMore: isLoadingMore,
    loadMore: loadMore
  });
  var pastChats = items.filter(function (conversation) {
    return conversation.id !== excludeConversationId;
  });
  var listRef = (0, _react.useRef)(null);
  function togglePastChat(conversation) {
    setSelectedPastChats(function (current) {
      return current.some(function (selected) {
        return selected.id === conversation.id;
      }) ? current.filter(function (selected) {
        return selected.id !== conversation.id;
      }) : [].concat(_toConsumableArray(current), [{
        id: conversation.id,
        name: conversation.name
      }]);
    });
  }
  function attachSelectedPastChats() {
    selectedPastChats.forEach(onAttachConversation);
    onClose();
  }
  function renderPastChat(conversation) {
    var isAlreadyAttached = attachedConversationIds.includes(conversation.id);
    var isSelected = isAlreadyAttached || selectedPastChats.some(function (selected) {
      return selected.id === conversation.id;
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_label.Label, {
      "data-testid": "chat-composer-past-chat",
      className: "flex w-full items-center gap-2 rounded-md px-3 py-2 font-normal hover:bg-accent",
      "data-sentry-element": "Label",
      "data-sentry-component": "renderPastChat",
      "data-sentry-source-file": "attach-past-chats-sheet.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.Checkbox, {
        checked: isSelected,
        disabled: isAlreadyAttached,
        onCheckedChange: function onCheckedChange() {
          return togglePastChat(conversation);
        },
        "data-sentry-element": "Checkbox",
        "data-sentry-source-file": "attach-past-chats-sheet.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_truncatedTextWithCursorTooltip.TruncatedTextWithCursorTooltip, {
        text: conversation.name,
        "data-sentry-element": "TruncatedTextWithCursorTooltip",
        "data-sentry-source-file": "attach-past-chats-sheet.tsx"
      }), (0, _chatComposerPastChatsList.pastChatWorkspaceBadge)(conversation.projectName)]
    }, conversation.id);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_importedBottomSheet.BottomSheet, {
    onClose: onClose,
    title: "Attach Past Chat",
    description: "Select past chats to give this conversation context",
    confirm: {
      label: attachPastChatsButtonLabel(selectedPastChats.length),
      onConfirm: attachSelectedPastChats,
      isDisabled: selectedPastChats.length === 0
    },
    scrollAreaRef: listRef,
    "data-sentry-element": "BottomSheet",
    "data-sentry-component": "AttachPastChatsSheet",
    "data-sentry-source-file": "attach-past-chats-sheet.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_searchInput.SearchInput, {
      "data-autofocus": true,
      className: "shrink-0",
      placeholder: "Search past chats\u2026",
      "aria-label": "Search past chats",
      value: query,
      onValueChange: setQuery,
      "data-sentry-element": "SearchInput",
      "data-sentry-source-file": "attach-past-chats-sheet.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ref: listRef,
      className: _importedBottomSheet.IMPORTED_SHEET_LIST_CLASS,
      children: [pastChats.map(renderPastChat), (0, _chatComposerPastChatsList.pastChatsNotice)(isLoadingInitial, hasError, pastChats.length), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: sentinelRef
      })]
    })]
  });
}